import { BASE_URL } from '../../Resources/Api';
import axios from "axios";

// const authToken = localStorage.getItem('accessToken');

// Get User List
export function getAssetList(toast, authToken) {
   return async function (dispatch) {
      dispatch({
         type: 'LOADING_STATUS',
         payload: {
            status: true,
            string: 'list'
         }
      })

      axios({
         method: 'GET',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'asset-list',
      })
         .then(function (response) {
            // console.log('Assets Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  dispatch({
                     type: 'GET_ASSET_LIST',
                     payload: response.data.data
                  })
                  dispatch({
                     type: 'LOADING_STATUS',
                     payload: {
                        status: false,
                        string: 'list'
                     }
                  })
               } else {
                  dispatch({
                     type: 'LOADING_STATUS',
                     payload: {
                        status: false,
                        string: 'list'
                     }
                  })
                  toast.warn('No reord found');
               }
            } else {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: {
                     status: false,
                     string: 'list'
                  }
               })
               toast.warn(response.data.message);
            }
         })
         .catch(function (error) {
            dispatch({
               type: 'LOADING_STATUS',
               payload: false
            })
            toast.error('Something went wront. Please try again');
            console.log(error);
         });
   }
}

// Save Action
export function saveAssetList(values, actions, setOpenModal, actionMode, toast, authToken) {
   return async function (dispatch) {
      console.log(values)
      actions.setSubmitting(true)

      axios({
         method: 'POST',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'asset-list',
         data: {
            id: values.id,
            asset_id: values.asset_id,
            qr_code: values.qr_code
         }
      })
         .then(function (response) {
            // console.log('Banner Category Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  toast.success(response.data.message)
                  actions.setSubmitting(false)
                  actions.resetForm()
                  actions.setFieldValue('asset_id', values.asset_id)
                  if(actionMode === "Edit"){
                     setOpenModal(false)
                     dispatch(getAssetList(toast, authToken));
                  }
               } else {
                  actions.setErrors(response.data.message)
                  actions.setSubmitting(false)
               }
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.error('Something went wrong. Please try again.')
            console.log(error);
         });
   }
}


// Delete User
export function deleteAssetList(values, actions, setOpenConfirm, toast, authToken) {
   return async function (dispatch) {
      // console.log(id)
      actions.setSubmitting(true)
      dispatch({
         type: 'MESSAGE',
         payload: false
      })

      axios({
         method: 'DELETE',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: `${BASE_URL}asset-list/${values.id}`,
      })
         .then(function (response) {
            // console.log('Auth Action=================', response);
            if (response.status === 200) {
               if (response.data.status === true) {
                  actions.setSubmitting(false)
                  toast.success(response.data.message);
                  setOpenConfirm(false)
                  dispatch(getAssetList(toast, authToken));
               } else {
                  actions.setSubmitting(false)
                  toast.warn(response.data.message);
               }
            } else {
               actions.setSubmitting(false)
               toast.success(response.data.message);
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.success("Something went wrong. Please tryagain.");
            console.log(error);
         });
   }
}


// Delete User
export function statusAssetList(values, actions, setOpenConfirm, toast, authToken) {
   return async function (dispatch) {
      // console.log(id)
      actions.setSubmitting(true)

      axios({
         method: 'PATCH',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: `${BASE_URL}asset-list/${values.id}`,
         data: {
            status: values.status
         }
      })
         .then(function (response) {
            // console.log('Auth Action=================', response);
            if (response.status === 200) {
               if (response.data.status === true) {
                  actions.setSubmitting(false)
                  toast.success(response.data.message);
                  setOpenConfirm(false)
                  dispatch(getAssetList(toast, authToken));
               } else {
                  actions.setSubmitting(false)
                  toast.warn(response.data.message);
               }
            } else {
               actions.setSubmitting(false)
               toast.warn(response.data.message);
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.success("Something went wrong. Please tryagain.");
            console.log(error);
         });
   }
}

